<template>
  <block class="similar-combo-list-component"
         title="相关系列推荐"
         :more="false"
         more-desc=""
  >
    <div class="similar-combo-list-block"
         v-for="(productItem, productIndex) in list"
         :key="productIndex"
    >
      <item class="similar-combo-list-block-item"
            :item="productItem"
      />
    </div>
  </block>
</template>

<script>
  import Block from '@/components/Block';
  import Item from '@/components/ProductList/Item';

  export default {
    name: 'SimilarComboList',
    components: {
      Block,
      Item,
    },
    props: {
      list: {
        type: Array,
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .similar-combo-list {
    &-component {
      border-bottom: @size-extra-small solid @background-color-base;
      width: 100%;
      background: @color-white;
    }
    &-block-title {
      box-sizing: border-box;
      padding: @size-base @size-base 0 @size-base;
      color: @color-text-base;
      font-size: @font-size-medium;
      font-weight: @font-weight-bold;
      line-height: 1;
    }
    &-block-item {
      &:not(:last-child) {
        margin-bottom: @size-medium;
      }
    }
  }

</style>
